import React from 'react';
import { useTranslation } from 'react-i18next';
import '../../KindergartenServices/KindergartenServicesTranslate'
import { Content } from '../../../components/ThemeProvider/ThemeStyle';
import support from '../../../_assets/images/Support.png'
import {
    StyledQuestions,
    StyledQuestionsCard,
    StyledQuestionsCardImg,
    StyledQuestionsCards,
    StyledTitle
} from "../UniversalServicesStyle";


function UniversalVoucherServicesQuestions({contentWidth}) {
    const { t } = useTranslation();

    return (
        <StyledQuestions>
            <Content contentWidth={contentWidth}>
                <StyledTitle children={t('kindergarten_article_h1')} />
            </Content>
            <Content contentWidth={contentWidth}>
                <StyledQuestionsCards>
                    <StyledQuestionsCard>
                        <div
                            onClick={() => {
                                window.open('https://youtrack.dlife.kz/form/300fdec1-bdeb-40c5-b5df-34238afefc27', '_blank');
                            }}
                        >
                            <StyledQuestionsCardImg>
                                <img src={support} alt={t('kindergarten_support')}/>
                            </StyledQuestionsCardImg>
                            <p>{t('kindergarten_support')}</p>
                        </div>
                    </StyledQuestionsCard>
                </StyledQuestionsCards>
            </Content>
        </StyledQuestions>
    );
}

export default UniversalVoucherServicesQuestions;